import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {SeriesCorrectionOutputData, isCompletedOutput} from "../../../_models/jobs/series-correction-job";
import {ModelID, KeyMap} from "../../../_typing/generic-types";
import {take, tap} from "rxjs/operators";
import {ListResponse} from "../../../services/api/response-types";
import {Series} from "../../../_models/series";
import {takeUntil} from "rxjs";
import {SeriesDataService} from "../../../services/series_data.service";
import {BaseComponent} from "../../../shared/base.component";
import {SharedPipesModule} from "../../../shared/modules/shared-pipes.module";


@Component({
    selector: 'series-correction-job-output-data',
    templateUrl: './series-correction-job-output-data.component.html',
    styleUrls: ['./series-correction-job-output-data.component.scss'],
    imports: [
        SharedPipesModule
    ],
})
export class SeriesCorrectionJobOutputDataComponent extends BaseComponent {
    @Input() outputData: SeriesCorrectionOutputData;
    seriesDict: KeyMap<Series> = {};
    isCompletedOutput = isCompletedOutput;

    constructor(private seriesDataService: SeriesDataService,
                private cdr: ChangeDetectorRef) {
        super();
    }

    ngOnInit() {
        if (!isCompletedOutput(this.outputData)) return
        const seriesIds: ModelID[] = this.outputData.corrected
            .reduce((acc, a) => [...acc, a.series_id], []);
        //TODO Replace with fetch from ngxs store
        console.log('seriesIds: ', seriesIds);
        this.seriesDataService.getSeriesListByIds(seriesIds).pipe(
            take(1), tap((seriesList: ListResponse<Series>) => {
                seriesList.data.forEach(s => this.seriesDict[s.id] = s);
                this.cdr.markForCheck();
            }),
            takeUntil(this.onDestroy)
        ).subscribe()
    }

}
